const body = document.getElementsByTagName("body")[0];
const hr = document.querySelectorAll("div:not(.sidenav) > hr");
const sidebarWhite = document.querySelectorAll(".sidenav.bg-white");
const hr_card = document.querySelectorAll("div:not(.bg-gradient-dark) hr");
const text_btn = document.querySelectorAll("button:not(.btn) > .text-dark");
const text_span = document.querySelectorAll(
  "span.text-dark, .breadcrumb .text-dark"
);
const text_span_white = document.querySelectorAll("span.text-white");
const text_strong = document.querySelectorAll("strong.text-dark");
const text_strong_white = document.querySelectorAll("strong.text-white");
const text_nav_link = document.querySelectorAll("a.nav-link.text-dark");
const secondary = document.querySelectorAll(".text-secondary");
const bg_gray_100 = document.querySelectorAll(".bg-gray-100");
const bg_gray_600 = document.querySelectorAll(".bg-gray-600");
const btn_text_dark = document.querySelectorAll(
  ".btn.btn-link.text-dark, .btn .ni.text-dark"
);
const btn_text_white = document.querySelectorAll(
  ".btn.btn-link.text-white, .btn .ni.text-white"
);
const card_border = document.querySelectorAll(".card.border");
const card_border_dark = document.querySelectorAll(".card.border.border-dark");
const svg = document.querySelectorAll("g");
const navLinks = document.querySelectorAll(
  ".navbar-main .nav-link, .navbar-main .breadcrumb-item, .navbar-main .breadcrumb-item a, .navbar-main h6"
);
const cardNavLinksIcons = document.querySelectorAll(".card .nav .nav-link i");
const cardNavSpan = document.querySelectorAll(".card .nav .nav-link span");

// Swap a class on every element that currently has `from` (optionally
// adding an extra class), leaving the others untouched.
function swapClass(elements, from, to, extra) {
  elements.forEach((el) => {
    if (el.classList.contains(from)) {
      el.classList.remove(from);
      el.classList.add(to);
      if (extra) el.classList.add(extra);
    }
  });
}

// Remove `from` and add `to` unconditionally.
function replaceClass(elements, from, to) {
  elements.forEach((el) => {
    el.classList.remove(from);
    el.classList.add(to);
  });
}

// Set the `fill` attribute on every <g> that already declares one.
function setSvgFill(color) {
  svg.forEach((el) => {
    if (el.hasAttribute("fill")) {
      el.setAttribute("fill", color);
    }
  });
}

export function activateDarkMode() {
  body.classList.add("bg-gray-600", "dark-version");

  swapClass(cardNavLinksIcons, "text-dark", "text-white");
  cardNavSpan.forEach((el) => {
    if (el.classList.contains("text-sm")) el.classList.add("text-white");
  });
  swapClass(hr, "dark", "light");
  swapClass(hr_card, "dark", "light");
  swapClass(text_btn, "text-dark", "text-white");
  swapClass(text_span, "text-dark", "text-white");
  swapClass(text_strong, "text-dark", "text-white");
  swapClass(text_nav_link, "text-dark", "text-white");
  swapClass(secondary, "text-secondary", "text-white", "opacity-8");
  swapClass(bg_gray_100, "bg-gray-100", "bg-gray-600");
  replaceClass(btn_text_dark, "text-dark", "text-white");
  sidebarWhite.forEach((el) => el.classList.remove("bg-white"));
  setSvgFill("#fff");
  card_border.forEach((el) => el.classList.add("border-dark"));
}

export function deactivateDarkMode() {
  body.classList.remove("bg-gray-600", "dark-version");
  body.classList.add("bg-gray-100");

  swapClass(navLinks, "text-dark", "text-white");
  swapClass(cardNavLinksIcons, "text-white", "text-dark");
  cardNavSpan.forEach((el) => {
    if (el.classList.contains("text-white")) el.classList.remove("text-white");
  });
  swapClass(hr, "light", "dark");
  swapClass(hr_card, "light", "dark");
  swapClass(text_btn, "text-white", "text-dark");
  text_span_white.forEach((el) => {
    if (
      el.classList.contains("text-white") &&
      !el.closest(".sidenav") &&
      !el.closest(".card.bg-gradient-dark")
    ) {
      el.classList.remove("text-white");
      el.classList.add("text-dark");
    }
  });
  swapClass(text_strong_white, "text-white", "text-dark");
  secondary.forEach((el) => {
    if (el.classList.contains("text-white")) {
      el.classList.remove("text-white", "opacity-8");
      el.classList.add("text-dark");
    }
  });
  swapClass(bg_gray_600, "bg-gray-600", "bg-gray-100");
  setSvgFill("#252f40");
  btn_text_white.forEach((el) => {
    if (!el.closest(".card.bg-gradient-dark")) {
      el.classList.remove("text-white");
      el.classList.add("text-dark");
    }
  });
  card_border_dark.forEach((el) => el.classList.remove("border-dark"));
}